export enum OperatingSystem {
  iOS = 'iOS',
  android = 'Android',
  iPad = 'iPad',
}
